import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../lang/LangEnum';
import { OrderSummaryTestIds } from '../../../../../../utils/testIds/OrderSummary.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { getOrderSummaryActionButtonStyles } from './orderSummaryActions.styles';

interface ContinueToConditionsButtonProps {
  onClick: () => void;
}

const ContinueToConditionsButton = ({ onClick }: ContinueToConditionsButtonProps) => {
  const { translate } = useTranslation();

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      size="large"
      onClick={onClick}
      testId={OrderSummaryTestIds.CONTINUE_TO_CONDITIONS_BUTTON}
      sx={getOrderSummaryActionButtonStyles}
    >
      <Typography noWrap>{translate(LangEnum.GLOBAL_CONTINUE)}</Typography>
    </Button>
  );
};

export default ContinueToConditionsButton;
